import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import LinkButton from '../atoms/button/LinkButton';
import Flight from './Flight';
import ItinerarySchedule from './ItinerarySchedule';
import { AIRLINES, BOOKING_CLASS_CLASS_J, ENABLE_MULTIPLE_HOTEL_PLAN } from '../../constants';
import { getCarrierName } from '../../utils/plain';

const SubscriptionTableItem = ({
  index,
  outboundFlight,
  inboundFlight,
  dateDisplay,
  plan,
  planOptions,
  questionAndAnswers,
  onQuestionAnswerChange,
  startDate,
  handleFlightChange,
  handlePlanChange,
  handlePlanDelete,
  cantChangeHotel,
  cantDeleteHotel,
  handleUpdateCheckin,
  finalConfirm,
  hideCheckin,
  handleUpdateQuestion,
  showQuestions,
  hideMessage,
  isLastDay,
  isFirstDay,
}) => {
  const rowSpan = ((outboundFlight) ? 2 : 1) + (planOptions.length > 0 ? planOptions.length : 0);
  const isHaveOption = planOptions.length > 0;
  const isLastDayAndHaveOption = isLastDay && isHaveOption;
  const isMiddleDayAndHaveOption = !isFirstDay && !isLastDay && isHaveOption;
  let planOptionRowSpan = 1;
  let flightRowSpan = rowSpan;
  if(isLastDayAndHaveOption || isMiddleDayAndHaveOption){
    planOptionRowSpan = rowSpan;
    flightRowSpan = 1;
  }

  const flight = outboundFlight || inboundFlight;
  const connectingFlights = flight && flight.connectingFlights;

  // 回答が入力されたらstateを更新
  const handleQuestionAnswerChange = (itineraryIndex, questionIndex, value) => {
    if (onQuestionAnswerChange) {
      onQuestionAnswerChange(itineraryIndex, questionIndex, value);
    }
  };

  // 同日にplanOptionがある場合
  const previousIsPlanOption = isHaveOption;

  const planItem = (
    <React.Fragment>
      <td className="tdItinerary">
        <ItinerarySchedule
          plan={plan}
          hideCheckin={cantChangeHotel}
          hideMessage={hideMessage}
          handleUpdateCheckin={handleUpdateCheckin}
          finalConfirm={finalConfirm}
          showQuestions={showQuestions}
          handleUpdateQuestion={handleUpdateQuestion}
          previousIsPlanOption={previousIsPlanOption}
        />
      </td>
      {finalConfirm ? (
        <td className="tdItineraryLast">
          <div className="mealItems">
            <div className="mealItem">
              {plan && plan.mealCondition}
            </div>
            {/* <div className="mealItem">
              夕食
              <span className="blue">あり</span>
            </div>
            <div className="mealItem">
              朝食
              <span className="red">なし</span>
            </div> */}
          </div>
          <div className="checkinTime">
            {!hideCheckin && plan && (
              <div className="checkin">
                <span className="name">チェックイン時間</span>
                <span className="time">{plan.checkin}</span>
              </div>
            )}
            {/* <div className="checkin">
              <span className="name">朝食時間</span>
              <span className="time">TODO 10:00</span>
            </div> */}
          </div>
          {showQuestions && plan && plan.questions && plan.questions.map((q, i) => (
            <div key={i} className="checkinTime">
              <div className="checkin">
                <span className="name">{`${q.title} :`}</span>
                <span className="time">{q.selectionText || '回答なし'}</span>
              </div>
            </div>
          ))}
        </td>
      ) : (
        <td className="tdLinkButton">
          {!cantChangeHotel && (
            <React.Fragment>
              {index !== 1 && cantDeleteHotel && <LinkButton onClick={handlePlanChange}>宿泊プランを変更する</LinkButton>}
              {index !== 1 && cantDeleteHotel && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>) }
              {!cantDeleteHotel && (
                <LinkButton
                  onClick={handlePlanDelete}
                  className="mt-15"
                >
                  宿泊施設を削除する
                </LinkButton>
              )}
            </React.Fragment>
          )}
          {ENABLE_MULTIPLE_HOTEL_PLAN && !plan && (
            <React.Fragment>
              <LinkButton onClick={handlePlanChange}>宿泊施設を追加する</LinkButton>
              {index !== 1 && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>)}
            </React.Fragment>
          )}
        </td>
      )}
    </React.Fragment>
  );

  const planOptionItem = (option) => {
    const [isOpen, setIsOpen] = useState(false);
    const goods = option.goods ? option.goods : option;
    const goodsDetailInfo = goods.goodsDetailInfo ? goods.goodsDetailInfo : goods;
    const goodsBasicInfo = goods.goodsBasicInfo ? goods.goodsBasicInfo : goods;
    const noticeAndGuidance = goods.noticeAndGuidance ? goods.noticeAndGuidance : goods;
    const questions = goods.facilityQuestions ? goods.facilityQuestions : goods.questions;
    const isGroup = goods.goodsDetailInfo ? goods.goodsDetailInfo.useUnit === 'group' : goods.useUnit === 'group';

    // 人数 or 台数の合計を計算
    let totalCount;
    if(isGroup){
      const targetYear = option.peopleCounts.DATE.split('-')[0];
      const targetMonth = option.peopleCounts.DATE.split('-')[1];
      const targetDay = option.peopleCounts.DATE.split('-')[2];
      const targetCalendar = goods.calendarList ? goods.calendarList.find((calendar) => calendar.year === targetYear && calendar.month === targetMonth && calendar.day === targetDay) : null;
      const numberOfGroups = targetCalendar ? targetCalendar.chargesList.find((charge) => charge.kind === 'AD').numberOfGroups : goods.useCount;
      totalCount = Number(numberOfGroups);
    }else{
      const _totalCount = Object.entries(option.peopleCounts)
      .filter(([key]) => key !== "DATE" && key !== "chargesList" && !/Price$/.test(key))
      .reduce((sum, [, value]) => sum + Number(value), 0);
      totalCount = Number(_totalCount);
    }

    return(
      <React.Fragment key={option.itineraryIndex}>
        <td className="tdItinerary">
          <div className="itinerary">
            <div className="itineraryTitle">{goodsDetailInfo.categoryDetail}</div>
            <div className="itineraryContent planOptionTitle">{goods.landFacilityName} {goods.goodsName} {goods.goodsPlanName}</div>
            <div className="itineraryCount">{totalCount}{goodsDetailInfo.displayUnit}</div>
          </div>

          {(goodsBasicInfo.planExplanationDetail || noticeAndGuidance.noticeAndOthers) && <div className="itineraryPlanOptionDetail" onClick={() => setIsOpen(!isOpen)}>
            <span className="title">ご案内ご注意・プラン詳細</span>
            <div className={`content ${isOpen ? 'isOpen' : 'isClose'}`}>
              <p dangerouslySetInnerHTML={{ __html: noticeAndGuidance.noticeAndOthers }}></p>
              <p dangerouslySetInnerHTML={{ __html: goodsBasicInfo.planExplanationDetail }}></p>
            </div>
          </div>}

          {questions && questions.length > 0 && (
          <div className="itineraryQuestions">
            {
              questions.map((question, i) => (
                <div key={i} className="itineraryQuestion">
                  <div className="itineraryQuestionTitle">
                    <p className="title">施設からの質問</p>
                    <p className="content" dangerouslySetInnerHTML={{ __html: (question.content || question.question) }} />
                  </div>
                  <div className="itineraryQuestionAnswer">
                    <div className="itineraryQuestionAnswerTitle">
                      <p className="title">ユーザー回答</p>
                      {!finalConfirm ? ((question.required || question.isUserAnswerNeeded) ? <span className="requierd">※必須</span> : <span>※任意</span>) : ''}
                    </div>
                    {finalConfirm ? (
                      <div 
                        className="itineraryQuestionAnswerTextarea"
                        style={{ whiteSpace: 'pre-wrap' }}
                      >
                        {question.answer || '回答なし'}
                      </div>
                    ) : (
                      <textarea 
                        className="itineraryQuestionAnswerTextarea"
                        id={`${option.itineraryIndex}-${goods.goodsCode}-q${i}`} 
                        placeholder="回答を入力してください"
                        rows={3} 
                        maxLength={1200}
                        value={(() => {
                          if (!questionAndAnswers) {
                            return '';
                          }
                          const questionData = questionAndAnswers[option.itineraryIndex];
                          if (!questionData || !questionData.facilityQuestions || !questionData.facilityQuestions[i]) {
                            return '';
                          }
                          return questionData.facilityQuestions[i].answer || '';
                        })()}
                        onChange={(e) => handleQuestionAnswerChange(option.itineraryIndex, i, e.target.value)}
                      />
                    )}
                  </div>
                </div>
              ))
            }
          </div>
          )}
        </td>
        <td className="tdItineraryPlanOptionRight"></td>
      </React.Fragment>
    )
  };

  return (
    <React.Fragment>
      {(isLastDayAndHaveOption || isMiddleDayAndHaveOption) && (planOptions.map((match, i) => (
        <tr key={i}>
          {i===0 && <td rowSpan={planOptionRowSpan}>
            <div className="day">
              <div className="dayTitle">{index}日目</div>
              <div className="date">{dateDisplay}</div>
            </div>
          </td>}
          {planOptionItem(match)}
        </tr>
      )))}
      <tr>
        {!isLastDayAndHaveOption && !isMiddleDayAndHaveOption && (
          <td rowSpan={flightRowSpan}>
            <div className="day">
              <div className="dayTitle">{index}日目</div>
              <div className="date">{dateDisplay}</div>
            </div>
          </td>
        )}
        {(outboundFlight || inboundFlight) ? (
          <React.Fragment>
            <td className="tdItinerary">
              <div className="itinerary">
                <div className="itineraryTitle">{outboundFlight ? '行き' : '帰り'}</div>
                <div>
                  <Flight
                    flight={outboundFlight || inboundFlight}
                    seat={!finalConfirm}
                    disabledFlightNumber={finalConfirm}
                  />
                </div>
              </div>
              <div className="mt-15 itineraryCaution">
                ※空港～宿泊施設間のアクセス・所要時間は、お客様ご自身でご確認ください。<br/>
                <span className="textRed">（現地移動につきましてはお客様負担となります）</span>
              </div>
            </td>
            {finalConfirm ? (
              <td>
                <FlightName
                  flight={flight}
                  connectingFlights={connectingFlights}
                />
              </td>
            ) : (
              <td className="tdLinkButton">
                <LinkButton onClick={handleFlightChange}>利用便を変更する</LinkButton>
              </td>
            )}
          </React.Fragment>
        ) : planItem}
      </tr>
      {isFirstDay && isHaveOption && planOptions.map((match, i) => (
        <tr key={i} id={`test`}>
          {planOptionItem(match)}
        </tr>
      ))}
      {outboundFlight && (
        <tr>
          {planItem}
        </tr>
      )}
    </React.Fragment>
  );
};

SubscriptionTableItem.propTypes = {
  index: PropTypes.number.isRequired,
  outboundFlight: PropTypes.object,
  inboundFlight: PropTypes.object,
  dateDisplay: PropTypes.string,
  plan: PropTypes.object,
  planOptions: PropTypes.array,
  questionAndAnswers: PropTypes.array,
  onQuestionAnswerChange: PropTypes.func,
  startDate: PropTypes.string,
  handleFlightChange: PropTypes.func.isRequired,
  handlePlanChange: PropTypes.func.isRequired,
  handlePlanDelete: PropTypes.func.isRequired,
  cantChangeHotel: PropTypes.bool,
  cantDeleteHotel: PropTypes.bool,
  handleUpdateCheckin: PropTypes.func.isRequired,
  finalConfirm: PropTypes.bool,
  hideCheckin: PropTypes.bool,
  handleUpdateQuestion: PropTypes.func.isRequired,
  showQuestions: PropTypes.bool,
  hideMessage: PropTypes.bool,
  isLastDay: PropTypes.bool,
  isFirstDay: PropTypes.bool,
};

export default SubscriptionTableItem;

const FlightName = ({ flight, connectingFlights }) => {
  if (!flight) {
    return null;
  }

  return connectingFlights && connectingFlights.length ? (
    <React.Fragment>
      <FlightNameItem flight={connectingFlights[0]} />
      <div style={{ height: 80 }} />
      <FlightNameItem flight={connectingFlights[1]} />
    </React.Fragment>
  ) : (
    <FlightNameItem flight={flight} />
  );
};

FlightName.propTypes = {
  flight: PropTypes.object,
  connectingFlights: PropTypes.array,
};

const FlightNameItem = ({ flight }) => {
  if (!flight) {
    return null;
  }

  const carrierName = getCarrierName(flight);

  return (
    <React.Fragment>
      <div className="tableFlightNumber" style={{ display: 'flex', alignItems: 'center' }}>
        {`${carrierName}${String(flight.flightID || flight.id || '').padStart(3, '0')}`}
        {flight.airline === AIRLINES.jal && flight.bookingClass === BOOKING_CLASS_CLASS_J && (
          <img src="/dp-air/img/logo/jclass.png" alt="" style={{ height: 20, marginLeft: 5 }} />
        )}
      </div>
      {flight.operationCarrier && (
        <div>{flight.operationCarrier}運航</div>
      )}
    </React.Fragment>
  );
};

FlightNameItem.propTypes = {
  flight: PropTypes.object,
};
